import { useQuery } from '@tanstack/react-query'
import { getAdminDashboard, getPlatformMetrics } from '@/lib/api/admin/dashboard'

/**
 * Hook to fetch complete dashboard data
 * Auto-refreshes every 30 seconds
 */
export function useAdminDashboard() {
  return useQuery({
    queryKey: ['admin', 'dashboard'],
    queryFn: getAdminDashboard,
    refetchInterval: 30000, // 30 seconds
    staleTime: 20000, // Consider data stale after 20 seconds
  })
}

/**
 * Hook to fetch only platform metrics (lighter payload)
 * Auto-refreshes every 30 seconds
 */
export function usePlatformMetrics() {
  return useQuery({
    queryKey: ['admin', 'metrics'],
    queryFn: getPlatformMetrics,
    refetchInterval: 30000,
    staleTime: 20000,
  })
}
